!function(e){e.proofguide("/wp-content/themes/pp-v1.2-children/marangeli-aranzamendi/resources/guide.jpg")}(jQuery);
//# sourceMappingURL=scripts.min.js.map
